/**
 * Utility-Funktionen
 */

/**
 * Kombiniert Klassen-Namen zu einem String.
 * Filtert falsy Werte heraus (false, null, undefined, '').
 *
 * @example
 * cn('foo', 'bar') // => 'foo bar'
 * cn('foo', condition && 'bar') // => 'foo bar' oder 'foo'
 * cn(['foo', 'bar']) // => 'foo bar'
 */
export function cn(...inputs: (string | string[] | false | null | undefined)[]): string {
  return inputs
    .flat()
    .filter((x): x is string => typeof x === 'string' && x.length > 0)
    .join(' ');
}

/**
 * Parst den Body einer Fetch-`Response` typisiert.
 *
 * `Response.json()` ist im DOM-Lib als `Promise<any>` typisiert, wodurch jede
 * Zuweisung an eine typisierte Variable ein `no-unsafe-assignment`-Warning
 * ausloest - selbst mit expliziter Typ-Annotation an der Zielvariable, da das
 * `any` unveraendert durchgereicht wird. Diese Funktion buendelt die dafuer
 * noetige einzelne Typ-Assertion an einer einzigen Stelle (dem Rand zur
 * Fetch-API), statt sie an jeder Aufrufstelle zu wiederholen.
 *
 * Wichtig: Das ist keine Laufzeit-Validierung - der Aufrufer muss weiterhin
 * sicherstellen, dass die API tatsaechlich `T` liefert (z.B. per Server-seitigem
 * Zod-Schema).
 */
export async function parseJsonResponse<T>(response: Response): Promise<T> {
  return (await response.json()) as T;
}
